function getLocationOrigin() {
    try {
        return window.location.origin;
    }
    catch (err) {
        return '';
    }
}
function parseUrlOnly(url, baseUrlArg) {
    try {
        return new URL(url);
    }
    catch {
        // nothing
    }
    const baseUrl = baseUrlArg || getLocationOrigin();
    let finalBaseUrl;
    try {
        finalBaseUrl = new URL(baseUrl);
    }
    catch {
        finalBaseUrl = new URL(baseUrl, getLocationOrigin());
    }
    if (url.startsWith('/')) {
        return new URL(url, finalBaseUrl);
    }
    let { pathname } = finalBaseUrl;
    if (!pathname.endsWith('/')) {
        pathname += '/';
    }
    pathname += url;
    return new URL(pathname, finalBaseUrl);
}
export function parseUrl(url, baseUrlArg, params) {
    const urlObj = parseUrlOnly(url, baseUrlArg);
    params?.forEach((value, key) => urlObj.searchParams.append(key, value));
    return urlObj;
}
